const onlyNumbersParser = value => value.replace(/\D/g, '')

export default onlyNumbersParser